function isIPhone () {
  return window.navigator.userAgent.indexOf('iPhone') !== -1;
}

export default isIPhone;